const ADD_BTN = '[data-tour="user-group-add-button"]';
const STEP1_DIALOG = '[data-tour="user-group-dialog-step1"]';
const STEP1_INPUT = '[data-tour="user-group-dialog-step1-input"]';
const STEP1_CONTINUE = '[data-tour="user-group-dialog-step1-continue"]';
const STEP2_DIALOG = '[data-tour="user-group-dialog-step2"]';
const STEP2_INPUT = '[data-tour="user-group-dialog-step2-input"]';
const STEP2_DOLATER = '[data-tour="user-group-dialog-step2-dolater"]';
const STEP2_CONFIRM = '[data-tour="user-group-dialog-step2-confirm"]';
const EXPORT_BTN = '[data-tour="user-group-export-button"]';
const EDIT_BTN = '[data-tour="user-group-edit-button"]';
const EDIT_DIALOG = '[data-tour="user-group-edit-dialog"]';
const EDIT_INPUT = '[data-tour="user-group-edit-dialog-input"]';
const EDIT_SAVE = '[data-tour="user-group-edit-dialog-save"]';
const GROUP_USER_BTN = '[data-tour="user-group-button-group-user"]';
const GROUP_USER_DIALOG = '[data-tour="user-group-button-group-user-dialog"]';
const GROUP_ADMIN_BTN = '[data-tour="user-group-button-group-admin"]';
const GROUP_ADMIN_DIALOG = '[data-tour="user-group-button-group-admin-dialog"]';
const DELETE_BTN = '[data-tour="user-group-button-delete"]';
const DETAIL_TAB = '[data-tour="user-group-detail-tab"]';
const EMPLOYEE_TAB = '[data-tour="user-group-employee-tab"]';
const ADMIN_TAB = '[data-tour="user-group-admin-tab"]';

const closeAddDialog = () => window.__closeAddUserGroupDialog?.();
const closeAdvancedMenu = () => window.__closeUserGroupAdvancedMenu?.();
const closeEditDialog = () => window.__closeUserGroupEditDialog?.();
const closeActionsMenu = () => window.__closeUserGroupActionsMenu?.();
const closeUsersDialog = () => window.__closeUserGroupUsersDialog?.();
const closeAdminsDialog = () => window.__closeUserGroupAdminsDialog?.();
const closeDeleteDialog = () => window.__closeUserGroupDeleteDialog?.();

/** Chờ window handler được đăng ký sau khi dialog cha mount */
const waitForWindowFn = (name, timeout = 2000) =>
  new Promise((resolve, reject) => {
    const start = Date.now();
    const tick = () => {
      if (typeof window[name] === "function") {
        resolve(window[name]);
        return;
      }
      if (Date.now() - start >= timeout) {
        reject(new Error(`${name} not ready`));
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });

const openAddDialogFlow = async () => {
  closeAdvancedMenu();
  window.__openAddUserGroupDialog?.();
  try {
    const goStep1 = await waitForWindowFn("__goAddUserGroupStep1");
    goStep1();
  } catch (e) {
    console.warn(e);
  }
};

const openStep2Flow = async () => {
  closeAdvancedMenu();
  window.__openAddUserGroupDialog?.();
  try {
    const openFn = await waitForWindowFn("__openAddUserGroupStep2");
    openFn();
  } catch (e) {
    console.warn(e);
  }
};

const closeAddFlow = () => {
  window.__closeAddUserGroupStep2?.();
  closeAddDialog();
};

const openExportFlow = () => {
  closeAddFlow();
  closeEditDialog();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  closeActionsMenu();
  window.__openUserGroupAdvancedMenu?.();
};

const openEditButtonFlow = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  closeEditDialog();
  closeActionsMenu();
  // Force hiện nút Edit kể cả khi đang chọn nhóm All users (id=1)
  window.__showUserGroupEditActions?.();
};

const openEditDialogFlow = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  closeActionsMenu();
  window.__openUserGroupEditDialog?.();
};

const openGroupUserMenuFlow = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeEditDialog();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  window.__openUserGroupActionsMenu?.();
};

const openGroupUserDialogFlow = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeEditDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  closeActionsMenu();
  window.__openUserGroupUsersDialog?.();
};

const openGroupAdminMenuFlow = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeEditDialog();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  window.__openUserGroupActionsMenu?.();
};

const openGroupAdminDialogFlow = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeEditDialog();
  closeUsersDialog();
  closeDeleteDialog();
  closeActionsMenu();
  window.__openUserGroupAdminsDialog?.();
};

/** Highlight MenuItem Delete trong actions menu (không mở dialog) */
const openDeleteMenuFlow = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeEditDialog();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  window.__openUserGroupActionsMenu?.();
};

const goToDetailTab = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeEditDialog();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  closeActionsMenu();
  window.__setUserGroupInfoTab?.(0);
};

const goToEmployeeTab = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeEditDialog();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  closeActionsMenu();
  window.__setUserGroupInfoTab?.(1);
};

const goToAdminTab = () => {
  closeAddFlow();
  closeAdvancedMenu();
  closeEditDialog();
  closeUsersDialog();
  closeAdminsDialog();
  closeDeleteDialog();
  closeActionsMenu();
  window.__setUserGroupInfoTab?.(2);
};

// Trả về steps theo hàm để hỗ trợ i18n
export const getUserGroupTourSteps = (t) => [
  {
    selector: '[data-tour="drawer-user-groups-management"]',
    content: t("tour.user-group.drawer"),
  },
  {
    selector: ADD_BTN,
    content: t("tour.user-group.add-button"),
    tourOpen: () => {
      closeAddFlow();
      closeAdvancedMenu();
    },
  },
  {
    selector: STEP1_DIALOG,
    content: t("tour.user-group.dialog-step1"),
    tourOpen: openAddDialogFlow,
    tourWaitFor: STEP1_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [STEP1_DIALOG],
    resizeObservables: [STEP1_DIALOG],
  },
  {
    selector: STEP1_INPUT,
    content: t("tour.user-group.dialog-step1-input"),
    tourOpen: openAddDialogFlow,
    tourWaitFor: STEP1_INPUT,
    tourWaitFrames: 1,
  },
  {
    selector: STEP1_CONTINUE,
    content: t("tour.user-group.dialog-step1-continue"),
    tourOpen: openAddDialogFlow,
    tourWaitFor: STEP1_CONTINUE,
    tourWaitFrames: 1,
  },
  {
    selector: STEP2_DIALOG,
    content: t("tour.user-group.dialog-step2"),
    tourOpen: openStep2Flow,
    tourWaitFor: STEP2_DIALOG,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [STEP2_DIALOG],
    resizeObservables: [STEP2_DIALOG],
  },
  {
    selector: STEP2_INPUT,
    content: t("tour.user-group.dialog-step2-input"),
    tourOpen: openStep2Flow,
    tourWaitFor: STEP2_INPUT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [STEP2_INPUT],
    resizeObservables: [STEP2_INPUT],
  },
  {
    selector: STEP2_DOLATER,
    content: t("tour.user-group.dialog-step2-dolater"),
    tourOpen: openStep2Flow,
    tourWaitFor: STEP2_DOLATER,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [STEP2_DOLATER],
    resizeObservables: [STEP2_DOLATER],
  },
  {
    selector: STEP2_CONFIRM,
    content: t("tour.user-group.dialog-step2-confirm"),
    tourOpen: openStep2Flow,
    tourWaitFor: STEP2_CONFIRM,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [STEP2_CONFIRM],
    resizeObservables: [STEP2_CONFIRM],
    // Không dùng actionAfter closeAddFlow: Reactour gọi cleanup cả khi Prev
    // → đóng dialog khi back về Do later. Đóng ở openExportFlow khi Next.
  },
  {
    selector: EXPORT_BTN,
    content: t("tour.user-group.export-button"),
    tourOpen: openExportFlow,
    tourWaitFor: EXPORT_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [EXPORT_BTN],
    resizeObservables: [EXPORT_BTN],
    actionAfter: closeAdvancedMenu,
  },
  {
    selector: EDIT_BTN,
    content: t("tour.user-group.edit-button"),
    tourOpen: openEditButtonFlow,
    tourWaitFor: EDIT_BTN,
    tourWaitFrames: 1,
  },
  {
    selector: EDIT_DIALOG,
    content: t("tour.user-group.edit-dialog"),
    tourOpen: openEditDialogFlow,
    tourWaitFor: EDIT_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [EDIT_DIALOG],
    resizeObservables: [EDIT_DIALOG],
  },
  {
    selector: EDIT_INPUT,
    content: t("tour.user-group.edit-dialog-input"),
    tourOpen: openEditDialogFlow,
    tourWaitFor: EDIT_INPUT,
    tourWaitFrames: 1,
  },
  {
    selector: EDIT_SAVE,
    content: t("tour.user-group.edit-dialog-save"),
    tourOpen: openEditDialogFlow,
    tourWaitFor: EDIT_SAVE,
    tourWaitFrames: 1,
    // Không actionAfter closeEditDialog — Prev về input sẽ bị đóng dialog
  },
  {
    selector: GROUP_USER_BTN,
    content: t("tour.user-group.button-group-user"),
    tourOpen: openGroupUserMenuFlow,
    tourWaitFor: GROUP_USER_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
  },
  {
    selector: GROUP_USER_DIALOG,
    content: t("tour.user-group.button-group-user-dialog"),
    tourOpen: openGroupUserDialogFlow,
    tourWaitFor: GROUP_USER_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [GROUP_USER_DIALOG],
    resizeObservables: [GROUP_USER_DIALOG],
    // Đóng dialog ở step kế tiếp (openGroupAdminMenuFlow), không actionAfter
  },
  {
    selector: GROUP_ADMIN_BTN,
    content: t("tour.user-group.button-group-admin"),
    tourOpen: openGroupAdminMenuFlow,
    tourWaitFor: GROUP_ADMIN_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
  },
  {
    selector: GROUP_ADMIN_DIALOG,
    content: t("tour.user-group.button-group-admin-dialog"),
    tourOpen: openGroupAdminDialogFlow,
    tourWaitFor: GROUP_ADMIN_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [GROUP_ADMIN_DIALOG],
    resizeObservables: [GROUP_ADMIN_DIALOG],
  },
  {
    selector: DELETE_BTN,
    content: t("tour.user-group.button-delete"),
    tourOpen: openDeleteMenuFlow,
    tourWaitFor: DELETE_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [DELETE_BTN],
    resizeObservables: [DELETE_BTN],
  },
  {
    selector: DETAIL_TAB,
    content: t("tour.user-group.detail-tab"),
    tourOpen: goToDetailTab,
    tourWaitFor: DETAIL_TAB,
    tourWaitFrames: 1,
  },
  {
    selector: EMPLOYEE_TAB,
    content: t("tour.user-group.employee-tab"),
    tourOpen: goToEmployeeTab,
    tourWaitFor: EMPLOYEE_TAB,
    tourWaitFrames: 1,
  },
  {
    selector: ADMIN_TAB,
    content: t("tour.user-group.admin-tab"),
    tourOpen: goToAdminTab,
    tourWaitFor: ADMIN_TAB,
    tourWaitFrames: 1,
  },
];
